var React = require('react');

function HeroShape (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFFFFF","d":"M0,62.9c101.9,44.4,203.6,83.6,361.6,83.6H0V62.9z","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M837.7,146.4H361.6C544,146.4,687.9,72.2,838,12.6L837.7,146.4z","key":1})]);
}

HeroShape.defaultProps = {"version":"1.1","id":"Isolation_Mode","x":"0px","y":"0px","viewBox":"0 0 837.7 146.4","enableBackground":"new 0 0 837.7 146.4","xmlSpace":"preserve","preserveAspectRatio":"none"};

module.exports = HeroShape;

HeroShape.default = HeroShape;
